import React from "react";
import BhapticsFaqSection, {
  FaqHelp,
  FaqNotionTags,
} from "@/components/faq/BhapticsFaqSection";
import { cn } from "@/libs/utils";

const ProductFaq = ({
  tag,
  className,
  children = <FaqHelp />,
}: React.PropsWithChildren<{
  tag: FaqNotionTags | FaqNotionTags[];
  className?: string;
}>) => {
  return (
    <section
      className={cn("mx-auto w-full max-w-[952px] px-4 laptop:px-5", className)}
    >
      <h2 className="w-full pb-5 text-center text-3xl font-400 laptop:pb-8 laptop:text-left laptop:text-5xl">
        FAQ
      </h2>
      <BhapticsFaqSection className="pb-0" tag={tag} contents={children} />
    </section>
  );
};

export default ProductFaq;
